<template>
	<div class="link-auto-table-filter-tag" v-show="filterResultsDecodeData.results.length>0 || (columnFilterTags.length>0)">

		<!--	非逻辑表达式的组合查询	-->
		<template v-if="filterTags.length>0">
			<div v-for="(item,index) in filterTags" :key="item.id" class="link-auto-table-filter-tag-item" v-if="!!item" @click="lv_removeCombineFilter(item,index)">
				<!--{{item.name}}-{{item.type}}-{{item.value}}-{{item.operator}}-->
				<span>{{ item.name }}&nbsp;&nbsp;{{ operators[item.type][item.operator] }}&nbsp;&nbsp;“{{ item.value }}”</span>
				<link-icon icon="link-icon-close"/>
			</div>
		</template>
		<!--	逻辑表达式的组合查询	-->
		<template v-else-if="!!filterOperatorString">
			<div class="link-auto-table-filter-tag-item" @click="lv_clearCombineFilterOperator">
				<span>{{ filterOperatorString }}</span>
				<link-icon icon="link-icon-close"/>
			</div>
		</template>

		<!--	列筛选	-->
		<div v-for="(item) in columnFilterTags" :key="item.id" class="link-auto-table-filter-tag-item" @click="lv_removeColumnFilter(item)">
			<span>{{ item.name }}</span>
			<link-icon icon="link-icon-close"/>
		</div>
		<span class="link-auto-table-filter-tag-clear-button" @click="lv_clearAllFilters">{{ $t('LinkAutoTable.clearFilter') }}</span>
	</div>
</template>

<script>
import {makeFiltersRaw} from "../../components/lnk-combinefilter/utils";
import {decodeFilterResults} from "@link-components/combine-filter/combine-filter.utils";

/**
 * 由于combine filter 中filterResults数据结构的调整，导致这里filterResults需要做一些奇怪的判断
 * @author  韦胜健
 * @date    2021/3/16 15:37
 */
export default {
	name: "link-auto-table-filter-tag",
	props: {
		filterResults: {},
		filterOptions: {},
		filterOperator: {},
		columnParams: {},
	},
	watch: {
		filterResults: {
			immediate: true,
			handler() {
				this.reset()
			},
		},
		columnParams: {
			immediate: true,
			handler() {
				this.resetColumnFilter()
			},
		}
	},
	data() {
		return {
			/*各种筛选操作符对应显示名称*/
			operators: {
				normal: {
					"like": '模糊查询',
					"=": '等于',
					"in": '包含',
					"not in": '排除',
					"IS NULL": '为空查询',
					"NOT NULL": '非空查询',
				},
				number: {
					">": '大于',
					">=": '大于等于',
					"=": '等于',
					"<=": '小于等于',
					"<": '小于',
					"<>": '不等于',
					"between": '范围查询',
					"in": '包含',
					"not in": '排除',
					"like": '模糊查询',
					"IS NULL": '为空查询',
					"NOT NULL": '非空查询',
				},
				select: {
					"=": "等于",
					"in": "包含",
					"not in": "排除",
					"IS NULL": "为空查询",
					"NOT NULL": "非空查询",
				},
				date: {
					'>=': '晚于',
					'<=': '早于',
					'between': '范围查询',
					'like': '模糊查询',
					'IS NULL': '为空查询',
					'NOT NULL': '非空查询',
				},
				/* picklist */
				picklist: {
					'=': '等于',
					'in': '包含',
					'not in': '排除',
					'IS NULL': '为空查询',
					'NOT NULL': '非空查询',
				},
				multi: {
					"or like": "模糊匹配"
				},
			},
			/*筛选参数显示数组数据*/
			filterTags: [],
			/*组合查询逻辑表达式字符串*/
			filterOperatorString: null,
			/*列筛选参数显示数组数据*/
			columnFilterTags: [],
		}
	},
	computed: {
		filterResultsDecodeData() {
			return decodeFilterResults(this.filterResults)
		},
	},
	methods: {
		/**
		 * 用来显示筛选参数数组的tag
		 * @author  韦胜健
		 * @date    2018/12/5 11:27
		 */
		async reset() {
			this.filterTags = []
			this.filterOperatorString = null
			if (!this.filterOptions || this.filterOptions.length === 0) return

			const {results, compatible, isCompatible} = this.filterResultsDecodeData
			if (results.length === 0) return

			const ret = []
			for (let i = 0; i < results.length; i++) {
				const fr = results[i];
				const {id, type, condition: operator} = fr
				const name = this.lv_getNameByFields(fr.field)
				const data = {id, fr, name, type, operator, value: null, displayString: null}
				ret.push(data)
				switch (fr.condition) {
					case 'not in':
						if (!fr.isLink) {
							if (!!fr.value && fr.value.length > 0) {
								/*普通文本*/
								data.value = fr.value
							} else {
								/*值列表*/
								const selectValues = []
								for (let j = 0; j < fr.values.length; j++) {
									const value = fr.values[j];
									selectValues.push(await this.lv_getLovNameByFieldAndValue(fr.field, value))
								}
								data.value = selectValues.toString()
							}
						} else {
							/*对象*/
							const option = this.lv_getFilterOptionByField(fr.field)
							// console.log(option)
							const showNames = []
							fr.values.forEach(item => showNames.push(item[option.pickProps.showKey]))
							data.value = showNames.toString()
						}
						break;
					default:
						data.value = await this.lv_getValueByFilterResult(fr)
						break;
				}
			}
			const id2item = {}
			ret.forEach(item => {
				item.displayString = `${item.name} ${this.operators[item.type][item.operator]} "${item.value}"`
				id2item[item.id] = item
			})

			if (!isCompatible) {
				this.filterTags = ret
			} else {
				this.filterOperatorString = compatible.logicOperator
					.replace(/(或|(\s+(OR|or)\s+)|(\|+))/g, ' 或 ')
					.replace(/(且|(\s+(AND|and)\s+)|(&+))/g, ' 且 ')
					.replace(/([^且或\s()]+)/g, (...args) => {
						const item = id2item[args[1]]
						if (!item) return args[1]
						return `（${item.displayString}）`
					})
			}
		},
		/**
		 * 根据字段获取对应名称
		 * @author  韦胜健
		 * @date    2018/12/6 11:08
		 */
		lv_getNameByFields(fields) {
			switch (this.$lv.$utils.typeOf(fields)) {
				case 'string':
					return this.lv_getNameByField(fields)
				case 'array':
					return fields.reduce((ret, field) => {
						ret.push(this.lv_getNameByField(field))
						return ret
					}, []).join(',')
				default:
					return null
			}
		},
		/**
		 * 根据字段获取对应名称
		 * @author  韦胜健
		 * @date    2019/1/17 10:00
		 */
		lv_getNameByField(field) {
			const option = this.lv_getFilterOptionByField(field)
			if (!!option) return option.name
			if (field === 'created') return '创建时间'
			if (field === 'lastUpdated') return '更新时间'
		},
		/**
		 * 根据filterResult获取筛选值
		 * @author  韦胜健
		 * @date    2019/1/17 11:19
		 */
		async lv_getValueByFilterResult(filterResult) {
			if (!filterResult) return filterResult
			let value;
			if (!!filterResult.values && filterResult.values.length > 0) {
				value = filterResult.values
			}
			if (!!filterResult.value && filterResult.value.length > 0) {
				value = filterResult.value
			}
			if (filterResult.type === 'picklist' && this.$lv.$utils.typeOf(value) === 'array') return value.map(item => item[filterResult.field]).join(',')

			switch (this.$lv.$utils.typeOf(value)) {
				case 'string':
					return filterResult.type === 'select' ? await this.lv_getLovNameByFieldAndValue(filterResult.field, value) : value
				case 'array':
					const ret = []
					for (let i = 0; i < value.length; i++) {
						const vi = value[i];
						ret.push(filterResult.type === 'select' ? await this.lv_getLovNameByFieldAndValue(filterResult.field, vi) : vi)
					}
					return ret.join(',')
				default:
					return null
			}
		},
		/**
		 * 根据字段以及值获取值列表显示值
		 * @author  韦胜健
		 * @date    2019/1/17 11:20
		 */
		async lv_getLovNameByFieldAndValue(field, value) {
			const filterOption = this.lv_getFilterOptionByField(field)
			if (!!filterOption) return await this.$lov.getNameByTypeAndVal(filterOption.lov, value)
			return null
		},
		/**
		 * 根据字段获取对应的filterOption
		 * @author  韦胜健
		 * @date    2019/4/12 17:56
		 */
		lv_getFilterOptionByField(field) {
			for (let i = 0; i < this.filterOptions.length; i++) {
				const option = this.filterOptions[i];
				if (option.field === field) return option
			}
			return null
		},
		/**
		 * 处理点击删除筛选参数事件
		 * @author  韦胜健
		 * @date    2019/9/24 12:02
		 */
		async lv_removeCombineFilter(item, index) {
			this.filterResults.splice(index, 1)
			this.lv_emit()
		},

		/**
		 * 重新计算列筛选显示值
		 * @author  韦胜健
		 * @date    2019/9/24 14:00
		 */
		async resetColumnFilter() {
			const fields = Object.keys(this.columnParams)
			const columnFilterTags = []
			for (let i = 0; i < fields.length; i++) {
				const field = fields[i]
				const columnParam = this.columnParams[field]
				if (!columnParam) continue
				let text = []
				if (!!columnParam.linkSelectFilterData && columnParam.linkSelectFilterData.length > 0) {
					const toMuch = columnParam.linkSelectFilterData.length > 3
					text.push(`${columnParam.title}  包含  “${(toMuch ? columnParam.linkSelectFilterData.slice(0, 2) : columnParam.linkSelectFilterData).map(item => item.text)}${toMuch ? '......' : ''}”`)
				}
				if (!!columnParam.searchDynamicFilter) text.push(await columnParam.searchDynamicFilter.toText())
				text = text.filter(item => !!item)
				if (text.length === 0) continue
				columnFilterTags.push({name: text.join(' 并且 '), id: field, field,})
			}
			this.columnFilterTags = columnFilterTags
		},
		/**
		 * 删除列筛选值
		 * @author  韦胜健
		 * @date    2019/9/24 14:00
		 */
		lv_removeColumnFilter(item) {
			this.$delete(this.columnParams, item.field)
			this.lv_emit()
		},
		/**
		 * 删除组合查询逻辑表达式筛选
		 * @author  韦胜健
		 * @date    2021/3/18 10:02
		 */
		lv_clearCombineFilterOperator() {
			this.filterResults.splice(0, this.filterResults.length)
			this.lv_emit()
		},
		/**
		 * 清空所有筛选
		 * @author  韦胜健
		 * @date    2019/10/9 16:59
		 */
		async lv_clearAllFilters() {
			this.filterResults.splice(0, this.filterResults.length)
			Object.keys(this.columnParams).forEach(field => this.$delete(this.columnParams, field))
			this.lv_emit()
		},
		/**
		 * 派发筛选变化事件
		 * @author  韦胜健
		 * @date    2019/10/9 16:59
		 */
		async lv_emit() {
			const combineFiltersRaw = makeFiltersRaw(this.filterResults, this.filterOperator)
			this.$emit('change', {combineFiltersRaw})
		},
	},
}
</script>

<style lang="scss">
@include themeify {
	.link-auto-table-filter-tag {
		box-sizing: border-box;

		.link-auto-table-filter-tag-item {
			font-size: 12px;
			min-height: 24px;
			display: inline-flex;
			justify-content: flex-start;
			align-items: center;

			color: $color-normal-content;
			border: solid 1px #DCDEE2;
			box-sizing: border-box;
			padding: 0 6px;
			cursor: pointer;

			&:not(:last-child) {
				margin-right: 12px;
			}
		}

		.link-auto-table-filter-tag-clear-button {
			color: pl-var(color-primary);
			font-size: 12px;
			cursor: pointer;

			&:hover {
				color: pl-var(color-primary-deep);
			}
		}
	}
}
</style>
